<template>
  <!-- 投资详情顶部 -->
  <div class="InstitutionalInvestorTop main">
    <div class="marginLR">
      <el-row class="content">
        <el-col class="contentLeft" :xs="24" :sm="4">
          <img :src="msg.coverurl" alt="" />
        </el-col>
        <el-col class="contentCenter" :xs="24" :sm="14">
          <div class="companyName">
            {{msg.title}}
          </div>
          <div class="companyTime">
            成立时间： {{msg.create_time}}
          </div>
          <div class="afterDiv"></div>
        </el-col>
        <el-col class="contentRight" :xs="24" :sm="4" :offset="1">
          <div class="contentRightCollect">
            <img src="../../../../public/static/images/collect.png" alt="">
            <span>收藏</span>
          </div>
          <div class="contentRightButton">
            投送商业计划书
          </div>
        </el-col>
      </el-row>
      <div class="bottomMsg">
        {{msg.content}}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      msg: Object
    },
    components: {},
    data() {
      return {};
    },
    created: function () { },
    methods: {},
  };
</script>

<style scoped>
  @media (max-width: 768px) {
    .InstitutionalInvestorTop .marginLR {
      margin: 0 15px;
    }

    .InstitutionalInvestorTop .contentLeft {
      margin-top: 25px;
    }

    .InstitutionalInvestorTop .contentCenter {
      margin-top: 20px;
      margin-left: 0px
    }

    .InstitutionalInvestorTop .contentRight {
      text-align: center;
      margin-left: 0;
    }

    .InstitutionalInvestorTop .contentRightButton {
      margin-top: 20px;
    }

    .InstitutionalInvestorTop .bottomMsg {
      margin-top: 20px;
      padding-bottom: 25px;
    }
  }

  .InstitutionalInvestorTop {
    background-color: #262525;
    border-radius: 25px;
    margin-top: 40px;
  }

  .marginLR {
    margin: 0 35px;
  }

  .content {}

  .contentLeft {
    margin-top: 65px;

    background-color: #ffffff;
    border-radius: 5px;
  }

  .contentLeft img {
    display: block;
    margin: 15% auto;
  }

  .contentCenter {
    margin-top: 55px;
    margin-left: 40px;
  }

  .companyName {

    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .companyTime {
    margin-top: 6px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    letter-spacing: 1px;
    color: #a1a1a1;
  }

  .afterDiv {
    margin-top: 15px;
    width: 126px;
    height: 10px;
    background-color: #00ffff;
    border-radius: 4px;
  }

  .contentRight {
    margin-top: 22px;
    text-align: right;
  }

  .contentRightCollect {

    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333434;
  }

  .contentRightCollect>span {
    margin-left: 6px;
  }

  .contentRightButton {
    margin-top: 60px;
    text-align: center;

    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
    padding: 12px 0;
    background-color: #ff00ff;
    border-radius: 20px;
  }

  .bottomMsg {
    margin-top: 44px;
    padding-bottom: 47px;

    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 29px;
    letter-spacing: 0px;
    color: #ffffff;
  }
</style>